const CptName = 'ComLine'
function formatData (node) {
  // console.dir(node);
  return {
    data: {
      children: []
    },
    cpt: CptName
  }
}

export default {
  name: 'line',
  formatData
}